import AiBotTracesAPI from 'dashboard/api/aiBot/traces';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  SET_META: 'SET_META',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId, ...filters }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotTracesAPI(botId).get(filters);
      commit(types.SET_RECORDS, response.data.payload);
      commit(types.SET_META, response.data.meta);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  show: async (_context, { botId, id }) => {
    try {
      const response = await new AiBotTracesAPI(botId).show(id);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.SET_META]($state, meta) {
    $state.meta = meta;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
